import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import {
  useViewportScroll,
  motion,
  useTransform,
  useMotionValue
} from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import './styles.css';
import { position } from '@chakra-ui/styled-system';
import imageVR from '../../images/imageVR.jpg';
import image3D from '../../images/image3D.jpg';
import { Box, VStack, Text, Image, Center } from "@chakra-ui/react";

export default function SideParallax() {
  const { scrollY } = useViewportScroll();
  // const y1 = useTransform(scrollY, [0, 300], [0, 200]);
  // const y2 = useTransform(scrollY, [0, 300], [0, -100]);

  const [ref1, inView1, entry1] = useInView({
    /* Optional options */
    threshold: 0.5,
    triggerOnce: false
  });

  const [ref2, inView2, entry2] = useInView({
    /* Optional options */
    threshold: 0.2,
    triggerOnce: false
  });

  // console.log(entry);

  // const [isInViewport, setIsInViewport] = useState(false);

  //console.log(window.innerHeight);
  //let coso = useRef(null);

  // useEffect(() => {
  //   console.log(coso.current.offsetTop);
  //   if (
  //     coso.current.offsetTop > scrollY &&
  //     coso.current.offsetTop < window.innerHeight
  //   ) {
  //     setIsInViewport(true);
  //   } else {
  //     setIsInViewport(false);
  //   }
  // }, [coso]);
  // useEffect(() => {
  //   scrollY.onChange(v => console.log(v));
  // }, [scrollY]);

  const variantimage1 = {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: {
      opacity: 0,
      scale: 1,
      x: 100
    }
  };

  const variantimage2 = {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: {
      opacity: 0,
      scale: 1,
      x: -100
    }
  };

  return (
      <Center w='100%' h='100%'>
        <Box w='30%' h='100%' bg='white' paddingTop='32%'>
          <motion.div
            animate={inView1 ? 'visible' : 'hidden'}
            variants={variantimage2}
            transition={{ duration: 1, ease: 'easeOut' }}
            ref={ref1}>
              <VStack h='80vh' w='100%' bg='white' textAlign='left'>
                <Image src={image3D} h='80%' w='70%' bg='red.200'/>
                <Box h='20%' w='70%' bg='white' ><Text fontWeight='bold' fontSize='20px' color='gray.600'>Modern Visualization</Text>
                  <Text fontWeight='semibold' fontSize='14px' color='gray.600'>Have you ever thought 
                  <br/> "This website creator must be a handsome fella!"
                  <br/> <br/> <br/> Me neither.</Text>
                </Box>
              </VStack> 
          </motion.div>
          
        </Box>
        <Box h='500px' w='2%' bg='white'/  >
        <Box w='30%' h='100%' bg='white' >
          <motion.div
            animate={inView2 ? 'visible' : 'hidden'}
            variants={variantimage1}
            transition={{ duration: 1, ease: 'easeOut' }}
            ref={ref2}>
              <VStack h='160vh' w='100%' bg='white'>
                <Image src={imageVR} h='40%' w='70%' bg='white'/>
                <Box h='10%' w='70%' bg='white' textAlign='left'>
                  <Text fontWeight='bold' fontSize='20px' color='gray.600'>Interface meets Technology</Text>
                  <Text fontWeight='semibold' fontSize='14px' color='gray.600'><br/>This is why 'Baby Boomer' told us to play outside. 
                  <br/> Say farewell to our social life.</Text>
                </Box>
              </VStack> 
          </motion.div>
        </Box>
      </Center>
  );
}

{/* <Box topPadding='500px' >
        <motion.div
          animate={inView ? 'visible' : 'hidden'}
          variants={variantimage1}
          transition={{ duration: 1, ease: 'easeOut' }}
          ref={ref}
        >
          <Box w='200px' h='200px' bg='gray.100'/>
          <Image h='400px' src={image3D}/>
        </motion.div>
        </Box>
      <motion.img
        src={imageVR}
        animate={inView ? 'visible' : 'hidden'}
        variants={variantimage1}
        transition={{ duration: 1, ease: 'easeOut' }}
        ref={ref}
        className="images"
      />
      <Box w='1000px' h='1000px' bg='gray.400'>
      
      </Box> */}